<template>
  <div class="invoice-row align-items-end flex-column flex-md-row px-i">
    <div class="invoice-info col-24 col-md-12 justify-content-center justify-content-md-start">
      <div class="invoice-info-cell">
        <h2 class="invoice-info-cell-row-title invoice-info-cell-main-title mb-1">
          {{ merchant.legal_name }}
        </h2>
        <p v-if="merchant.vat_number" class="invoice-info-cell-row invoice-info-cell-row-normal-font justify-content-center justify-content-md-start">
          VAT# {{ merchant.vat_number }}
        </p>
        <p v-if="merchant.mof_number" class="invoice-info-cell-row invoice-info-cell-row-normal-font justify-content-center justify-content-md-start">
          MOF# {{ merchant.mof_number }}
        </p>
        <p v-if="merchant.cr_number" class="invoice-info-cell-row invoice-info-cell-row-normal-font justify-content-center justify-content-md-start">
          CR# {{ merchant.cr_number }}
        </p>
        <template v-for="text in splitCompanyAddress" v-if="merchant.address">
          <p class="invoice-info-cell-row justify-content-center justify-content-md-start">
            {{ text }}
          </p>
        </template>
        <p v-if="merchantZipCityCountry" class="invoice-info-cell-row justify-content-center justify-content-md-start">
          {{ merchantZipCityCountry }}
        </p>
        <p v-if="merchant.phone_number" class="invoice-info-cell-row justify-content-center justify-content-md-start">
          {{ merchant.phone_number }}
        </p>
      </div>
    </div>
    <div class="invoice-info col-24 col-md-12 justify-content-end flex-wrap d-none d-md-flex">
      <div class="invoice-info-cell">
        <div class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            INVOICE DATE
          </p>
          <p>{{ invoice.date | formatDateInNumeric(true) }}</p>
        </div>
        <div v-if="invoice.due_date" class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            DUE DATE
          </p>
          <p>{{ invoice.due_date | formatDateInNumeric(true) }}</p>
        </div>
        <div class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            CURRENCY
          </p>
          <p>{{ invoice.currency_iso_code }}</p>
        </div>
      </div>
      <div class="invoice-info-cell">
        <div class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            {{ invoice.voucher_template.voucher_type }}#
          </p>
          <p>{{ invoice.merchant_invoice_number }}</p>
        </div>
        <div v-if="invoice.po_reference" class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            PO#
          </p>
          <p>{{ invoice.po_reference }}</p>
        </div>
        <div class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            REFERENCE#
          </p>
          <p>{{ invoice.tenant_invoice_number }}</p>
        </div>
      </div>
    </div>
    <div class="invoice-info invoice-info-mobile-stacked col-24 col-md-12 flex-wrap d-md-none">
      <div class="invoice-info-cell">
        <div class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            INVOICE NUMBER
          </p>
          <p>{{ invoice.merchant_invoice_number }}</p>
        </div>
        <div v-if="invoice.po_reference" class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            PO NUMBER
          </p>
          <p>{{ invoice.po_reference }}</p>
        </div>
        <div class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            DATE
          </p>
          <p>{{ invoice.date | formatDateInNumeric(true) }}</p>
        </div>
      </div>
      <div class="invoice-info-cell">
        <div v-if="invoice.due_date" class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            DUE DATE
          </p>
          <p>{{ invoice.due_date | formatDateInNumeric(true) }}</p>
        </div>
        <div v-if="invoice.customer_info" class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            CUSTOMER
          </p>
          <p>{{ invoice.customer_info['customer_display_name'] }}</p>
        </div>
        <div class="invoice-info-cell-row">
          <p class="invoice-info-cell-row-subtitle">
            AMOUNT
          </p>
          <p>{{ invoice.total | formatCurrency(invoice.currency_iso_code, currencyMinimumDigits) }}</p>
        </div>
        <div class="invoice-info-cell-row invoice-info-cell-row-negative-margin">
          <p class="invoice-info-cell-row-subtitle mb-0">
            STATUS
          </p>
          <div class="status-indicator status-indicator-rectangular flex-grow-0" :class="pillColorClass">
            {{ invoice.status }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MerchantInvoiceDetails",

  props: {
    invoice: { type: Object },
    merchant: { type: Object },
    pillColorClass: { type: String }
  },

  computed: {
    merchantZipCityCountry () {
      let { zip_code: zipCode = "", city: merchantCity = "" } = this.merchant;

      if (zipCode === null) {
        zipCode = "";
      }

      if (merchantCity === null) {
        merchantCity = "";
      }

      return this.displayAddress(zipCode, merchantCity, this.merchant.country_name);
    },

    splitCompanyAddress () {
      if (this.merchant && this.merchant.address) {
        return this.merchant.address.split("\r\n");
      } else {
        return "";
      }
    },

    currencyMinimumDigits () {
      if (this.invoice.currency_iso_code === "LBP") {
        return 0;
      } else {
        return 2;
      }
    }
  },

  methods: {
    displayAddress (zip, city, country) {
      let zipCity = `${zip} ${city}`.trim();

      if (country) {
        if (zipCity) {
          return `${zipCity}, ${country}`;
        } else {
          return country;
        }
      } else {
        return zipCity;
      }
    }
  }
};
</script>
